<template>
  <div>
    <v-card>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="nonZeroOutstanding"
        class="billing-table"
        :expand="false"
        item-key="actor.text"
        hide-actions
      >
        <template v-slot:items="props">
          <tr @click="props.expanded = !props.expanded">
            <td>{{ props.item.actor.text }}</td>
            <td>{{ props.item.total }} €</td>
            <td>{{ props.item.projects.length }}</td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <BillDataTable
            :billing-entry="props.item"
            :paginate="false"
            :show-total="false"
          />
        </template>
      </v-data-table>
      <v-snackbar v-model="showError" :timeout="7000"
        >Une erreur a eu lieu</v-snackbar
      >
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BillDataTable from "../billing/BillDataTable";

export default {
  components: { BillDataTable },
  data() {
    return {
      showError: false,
      loading: false,
      includeZero: false,
      headers: [
        { text: "Personne", value: "actor.text" },
        { text: "Total", value: "total" },
        { text: "Nombre de projets", value: "projects.length" }
      ]
    };
  },
  mounted() {
    this.fetch();
  },
  computed: {
    ...mapState("admin", ["nonZeroOutstanding"])
  },
  methods: {
    ...mapActions("admin", ["fetchOutstandingBillingList"]),
    async fetch() {
      this.loading = true;
      try {
        await this.fetchOutstandingBillingList();
      } catch {
        this.showError = true;
      }
      this.loading = false;
    }
  }
};
</script>
